module.exports = __webpack_public_path__ + "static/member4-13fa0b4c7b99c92f8695e4715886d251.png";